import { render, staticRenderFns } from "./RoomDelete.vue?vue&type=template&id=43cfc2e6&"
import script from "./RoomDelete.vue?vue&type=script&lang=js&"
export * from "./RoomDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports